import { render, staticRenderFns } from "./SubGrupoProdutoManage.vue?vue&type=template&id=65bb9fbf&scoped=true"
import script from "./SubGrupoProdutoManage.vue?vue&type=script&lang=js"
export * from "./SubGrupoProdutoManage.vue?vue&type=script&lang=js"
import style0 from "./SubGrupoProdutoManage.vue?vue&type=style&index=0&id=65bb9fbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb9fbf",
  null
  
)

export default component.exports